module.exports = __webpack_public_path__ + "0acc9cfa6d346ab4562ab78ec5ba78e1.pdf";